import React from 'react';

import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import { useIntl } from 'react-intl';

import { ICartEntry } from '@rbi-ctg/menu';
import useAddToCartRecentItem from 'hooks/use-add-to-cart-recent-item';
import { CustomEventNames } from 'state/mParticle';

import AddIcon from '../icons/add-icon';

import { IconButton, fill } from './styled';

interface AddToCartProps {
  disabled: boolean;
  cartEntry: ICartEntry;
  mParticleEvent?: CustomEventNames;
  mParticleUserLocation?: string;
}

const AddToCart: React.FC<AddToCartProps> = ({
  disabled,
  cartEntry,
  mParticleEvent,
  mParticleUserLocation,
}) => {
  const { formatMessage } = useIntl();
  const { addToCart, SwitchCartMethodDialog } = useAddToCartRecentItem({
    cartEntry,
    mParticleEvent,
    mParticleUserLocation,
  });

  return (
    <IconButton disabled={disabled} data-testid="add-to-cart" onClick={addToCart}>
      <VisuallyHidden>{formatMessage({ id: 'addToCart' })}</VisuallyHidden>
      <AddIcon fill={fill} />
      <SwitchCartMethodDialog />
    </IconButton>
  );
};

export default AddToCart;
